export const CELL_VALUE_CATEGORY_KEY = 'base' as const;
export const CELL_VALUE_PARENT_COMPONENT_KEY = 'table' as const;
export const CELL_VALUE_COMPONENT_KEY = 'cellValue' as const;
